"use client";

import { Button } from "@/components/ui/button";
import { DonistaClickLink } from "@/components/donista-click-link";
import { LoginButton } from "@/app/[locale]/(auth)/signin/_components/login-button";
import { useAppContext } from "@/contexts/app-context";
import { useTranslations } from "next-intl";

interface ShopCtaSectionProps {
    shopName: string;
    websiteUrl: string;
    isAmazon: boolean;
}

export function ShopCtaSection({ shopName, websiteUrl, isAmazon }: ShopCtaSectionProps) {
    const t = useTranslations("shops.detail");
    const { user } = useAppContext();

    const label = t("visitShop", { shopName });

    const cta = (
        <Button
            variant="default"
            asChild
            className="text-lg px-8 py-4.5 shadow-sm rounded-xl"
        >
            <DonistaClickLink href={websiteUrl}>
                {label}
            </DonistaClickLink>
        </Button>
    );

    if (user || isAmazon) {
        return cta;
    }

    // Anonymous users go straight to the shop (the click still generates a
    // donation); registration is offered as an optional, soft secondary action.
    return (
        <div className="flex flex-col gap-2 items-center md:items-start">
            {cta}
            <LoginButton
                variant="link"
                size="sm"
                title={t("registerToCollect")}
                className="text-sm text-muted-foreground h-auto p-0"
            />
        </div>
    );
}
